export enum TRIAL_USER_SOURCE {
  CAMPAIGN = "campaign",
  EXPRESS_INTEREST_MODAL = "expressInterestModal",
  DOMAIN_SETTINGS_DIALOG = "domainSettingsDialog",
  SEARCH_PAGE = "searchPage",
  CAMPAIGN_LANDING = "campaignLanding",
}
export enum PRICING_INTERVAL {
  MONTH = "month",
  YEAR = "year",
}

export enum SUBSCRIPTION_PLAN_NAME {
  BUY_SIDE_SEARCHER = "Buy-Side Searcher Plan",
  BUY_SIDE_TEAM = "BUY-Side Team Plan",
  BUY_SIDE_VIEW_ONLY = "Buy-Side View Plan",
  BUY_SIDE_EMERGING = "Buy-Side Emerging Plan",
}

export enum PRICING_INTERVAL_KEY {
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum SUBSCRIPTION_STATUS {
  TRAILING = "trialing",
  ACTIVE = "active",
  CANCELLED = "canceled",
  PASTDUE = "past_due",
}

export enum SUBSCRIPTION_DISPLAY_NAME {
  SEARCHER = "Searcher",
  TEAM = "Team",
  View = "View",
  EMERGING = "Emerging",
}

export enum LOOKUP_KEY {
  SEARCH = "search",
  COLLECTION = "collection",
  EMAIL_OUTREACH = "email-outreach",
  LETTER_OUTREACH = "letter-outreach",
  TEAM_MEMBERS = "team-members",
  SELLER_VERIFIED_LISTINGS = "seller-verified-listings",
  UNLIMITED_SEARCH = "unlimited-search",
  DEAL_TRACKER = "deal-tracker",
  COMMUNITY_AND_NEWSLETTER = "community-&-newsletter",
}

export enum FEATURE_HIGHLIGHT_NAME {
  TEAM_MEMBERS = "Team Members",
}

export enum FEATURE_NAME {
  COMMUNITY_AND_NEWSLETTER = "community-&-newsletter",
  EMAIL_OUTREACH = "email-outreach",
  SEARCH = "search",
  COLLECTION = "collection",
  LETTER_OUTREACH = "letter-outreach",
  DOMAINS = "domains",
  DEAL_TRACKER = "deal-tracker",
  MAILBOXES = "mailboxes",
  UNLIMITED_SEARCH = "unlimited-search",
  SELLER_VERFIED_Listings = "seller-verified-listings",
  COMPANY_COLLECTION = "Company Collection",
  TEAM_MEMBERS = "team-members",
}

export enum SUBSCRIPTION_VISIBILITY {
  UPGRADE = "upgrade",
  DOWNGRADE = "downgrade",
  PUBLIC = "public",
}

// interface highlightsDetails {
//   Search?: number;
//   "Email Outreach"?: number;
//   "Letter Outreach"?: number | null;
// }

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  isRecommended: boolean;
  displayName: string;
  price: number;
  pricingInterval: "month" | "year";
  productPricingId: string;
  createdAt: string;
  featureGroups: FeatureGroups;
}

export interface FeatureGroups {
  highlight: Feature[];
  included: Feature[];
}

export interface Feature {
  id: string;
  name: string;
  capacity: number | null;
  canHighlight: boolean;
  lookupKey: string;
  highlightName: string | null;
}

type UserFeatureQuota = {
  id: string | null;
  expiresAt: string | null;
  featureId: string | null;
  usedQuota: number | null;
  totalQuota: number | null;
  rolloverQuota: number | null;
  featureName: string | null;
  remainingQuota: number | null;
};

type ProductPricing = {
  id: string;
  price: number;
  currency: string;
  interval: string;
};
export interface CurrentSubscriptionDetails {
  id: string;
  userId: string;
  status: string;
  cancelAt: string | null;
  cancelledAt: string | null;
  daysUntilDue: number | null;
  startDate: string;
  endedAt: string | null;
  trialStart: string;
  trialEnd: string;
  productName: string;
  productPricing: ProductPricing;
  userFeatureQuotas: UserFeatureQuota[];
  hasScheduledDowngrade: boolean;
  currentPeriodEnd: string;
  product: {
    displayName: string;
    visibility: string;
  };
}
